import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
//import format from "date-fns/format";
//import {fetchUser,resetUser} from "../../actions/authAction";
import { fetchAppParameter } from "../../actions/optionAction";
import {

  Container,
  Segment,
  Button,
  // Header,
  // Confirm
} from "semantic-ui-react";




class AppParameterDetail extends Component {
  // state = {
  //   id: "",
  //   open: false,
  //   result: "show the modal to capture a result"
  // };

  componentDidMount() {
    if (this.props.parameter === null){
      this.props.fetchAppParameter()
        }
  }


  // componentWillUnmount() {
  //     this.props.resetUser();
  //   }
  render() {

    const {
      currentURL,
      imageInfoURL,
      imageProfileURL,
      limitCompany,
      limitBorrowLend,
      limitLocation,
      limitTask,
      limitRP,
      limitFinance,
      limitContact,
    } =
      this.props.parameter !== undefined &&
      this.props.parameter !== null &&
      this.props.parameter;

//********************


    return (
      <Container text>

        {/**/}
        <div className='cashbook-H'>

<div  style={{display: 'flex',flex: '90%',justifyContent: 'center',}} >
<div   style={{display: 'flex',justifyContent: 'center',fontSize:'1.3rem',fontWeight:'bold',padding:'5px'}}  >
  App Parameter Detail
</div>
</div>

{/*<div
style={{display: 'flex',flex: '10%',justifyContent: 'center',alignItems: 'center',}}
onClick={this.handleSearchSingleAccountFinance}>
      <span className='icon-button border1' > <Icon name='search' />Search</span >
    </div>*/}


</div>
{/**/}

        <Segment attached>
          <Button.Group size="mini" floated="right">


            <div ><Button
              // basic
              // inverted
              floated="right"
              size="mini"
              color="teal"
              type="button"
              as={Link}
              //target='_blank'
              to={`/appParameter/AppParameterEdit`}
            >
              Edit
            </Button></div>

          </Button.Group>
          <br />
          <br />
          <div >
        {currentURL && (
        <div className='rowERP'>
        <div className='sideERP'>
        <b>currentURL</b>
        </div>
        <div className='mainERP'>
        <b>{currentURL}</b>
        </div>

        </div>
        )}
        </div>

        <div >
          {imageInfoURL && (
        <div className='row'>
        <div className='side'>
        <b>imageInfoURL</b>
        </div>
        <div className='main'>
        <b>{imageInfoURL}</b>
        </div>

        </div>
        )}
        </div>

        <div >
        {imageProfileURL && (
        <div className='row'>
        <div className='side'>
        <b>imageProfileURL</b>
        </div>
        <div className='main'>
        <b>{imageProfileURL}</b>
        </div>

        </div>
        )}
        </div>


        <div >
        {limitCompany && (
        <div className='row'>
        <div className='side'>
        <b>limitCompany</b>
        </div>
        <div className='main'>
        <b>{limitCompany}</b>
        </div>

        </div>
        )}
        </div>


        <div >
        {limitBorrowLend && (
        <div className='row'>
        <div className='side'>
        <b>limitBorrowLend</b>
        </div>
        <div className='main'>
        <b>{limitBorrowLend}</b>
        </div>

        </div>
        )}
        </div>   
      
      
        <div >
        {limitLocation && (
        <div className='row'>
        <div className='side'>
        <b>limitLocation</b>
        </div>
        <div className='main'>
        <b>{limitLocation}</b>
        </div>

        </div>
        )}
        </div>


        <div >
        {limitTask && (
        <div className='row'>
        <div className='side'>
        <b>limitTask</b>
        </div>
        <div className='main'>
        <b>{limitTask}</b>
        </div>

        </div>
        )}
        </div>


        <div >
        {limitRP && (
        <div className='row'>
        <div className='side'>
        <b>limitRP</b>
        </div>
        <div className='main'>
        <b>{limitRP}</b>
        </div>

        </div>
        )}
        </div>


        <div >
        {limitFinance && (
        <div className='row'>
        <div className='side'>
        <b>limitFinance</b>
        </div>
        <div className='main'>
        <b>{limitFinance}</b>
        </div>

        </div>
        )}
        </div>

        <div >
        {limitContact && (
        <div className='row'>
        <div className='side'>
        <b>limitContact</b>
        </div>
        <div className='main'>
        <b>{limitContact}</b>
        </div>

        </div>
        )}
        </div>
        

        </Segment>
      </Container>
    );
  }

}


const mapStateToProps = (state) => {
  return {
    parameter:state.commons.parameter,

  };
};

export default connect(
  mapStateToProps,
  {fetchAppParameter}
)(AppParameterDetail);
